import { Autocomplete, Checkbox, FormControlLabel, TextField } from "@mui/material";

import { autoCompleteStyles } from "../../../../cm/Dashboard/FullPages/constant";
import FormField from "../../../../global/FormComponents/field/FormField";

const LawFirmSection = ({
  lawFirm,
  handleLawFirmToggle,
  lawFirmList,
  selectedLawFirm,
  handleLawFirmChange,
  setLawFirmSearch,
  disabled = false,
}) => (
  <>
    <FormControlLabel
      name="on_firm"
      label={<p>Involves the Law Firm</p>}
      control={<Checkbox color="success" checked={lawFirm} disabled={disabled} />}
      onChange={() => {
        if (disabled) {
          return;
        }
        handleLawFirmToggle();
      }}
      disabled={disabled}
    />
    {lawFirm && (
      <FormField label="Related Law Firm">
        <Autocomplete
          className="w-full"
          disablePortal
          options={lawFirmList ?? []}
          getOptionLabel={(option) => option?.label ?? option?.name ?? ""}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          noOptionsText="No Results"
          sx={{
            width: 300,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onChange={(event, option) => handleLawFirmChange(option?.id ?? null)}
          value={selectedLawFirm ?? null}
          disabled={disabled}
          renderOption={(props, option) => (
            <li {...props} id={`${option.id}`} key={`${option.id}`}>
              {option?.label ?? option?.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              id="related-law-firm"
              required
              placeholder="Search law firm"
              className="w-full"
              sx={{ ...autoCompleteStyles }}
              onChange={(event) => setLawFirmSearch?.(event.target.value)}
              onBlur={() => setLawFirmSearch?.("")}
            />
          )}
        />
      </FormField>
    )}
  </>
);

export default LawFirmSection;
